// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/*#app{*/\n/*height: calc(100% - 60px);*/\n/*scrollbar-width: none; !* firefox *!*/\n/*-ms-overflow-style: none; !* ie10+ *!*/\n/*overflow-x: hidden;*/\n/*overflow-y: auto;*/\n/*background: #304156;*/\n/*}*/\n/*#app::-webkit-scrollbar{*/\n/*display: none;*/\n/*}*/", ""]);
// Exports
module.exports = exports;
